import { useEffect, useMemo } from "react";

import { useAppDispatch } from "../redux/hooks";
import { Sport, setSport, useGetUser } from "../redux/slices";

export const useSetSport = () => {
  const dispatch = useAppDispatch();
  const { user, isLoading } = useGetUser();
  const sport: Sport = useMemo(() => user?.products?.FASTDRAW2?.[0]?.sport, [user]) || Sport.NO_SPORT;

  useEffect(() => {
    dispatch(setSport({ name: sport }));
  }, [dispatch, sport]);

  return { sport, isLoadingSport: isLoading };
};
